<div class="promotional home professional-promotion" data-testid="professional-promotion">
  <section class="hero" data-testid="professional-promotion-hero">
    <h1 class="display" data-testid="professional-promotion-title">For coaches and teachers who track progress</h1>
    <h2 data-testid="professional-promotion-subtitle">Use the Wheel of Life with your clients, students, or any group you guide.</h2>
  </section>

  <section data-testid="professional-promotion-content">
    <div class="wrap" data-testid="professional-promotion-wrap">
      <article class="step professional-promotion__card" data-testid="professional-promotion-card">
        <header data-testid="professional-promotion-card-header">
          <mat-icon class="professional-promotion__lock-icon" data-testid="professional-promotion-lock-icon">lock</mat-icon>
          <h3 data-testid="professional-promotion-plan-title">Professional plan</h3>
        </header>
        <section data-testid="professional-promotion-features-section">
          <ul class="professional-promotion__features" data-testid="professional-promotion-features">
            <li data-testid="professional-promotion-feature">Each person gets their own wheel with custom categories</li>
            <li data-testid="professional-promotion-feature">See how progress shifts over time — view in-depth session analytics</li>
            <li data-testid="professional-promotion-feature">Add private reflections that only you can see</li>
            <li data-testid="professional-promotion-feature">Perfect for self-assessment and skill tracking</li>
          </ul>
        </section>

        <p class="professional-promotion__notice" data-testid="professional-promotion-notice">
          I'll let you know when the plan will be available.
        </p>

        @if (!isSubmitted() && !hasError()) {
        <form
          [formGroup]="waitlistForm"
          (ngSubmit)="onSubmit()"
          class="professional-promotion__form"
          data-testid="professional-waitlist-form"
        >
          <input
            id="professional-waitlist-email"
            type="email"
            formControlName="email"
            placeholder="Enter your email"
            autocomplete="email"
            data-testid="professional-waitlist-email-input"
          />
          @if (waitlistForm.get('email')?.invalid && waitlistForm.get('email')?.touched) {
          <p class="professional-promotion__validation" data-testid="professional-waitlist-email-error">
            Please enter a valid email address
          </p>
          }

          <input type="hidden" formControlName="plan" data-testid="professional-waitlist-plan-input" />
          <input
            class="professional-promotion__honeypot"
            type="text"
            formControlName="nickname"
            tabindex="-1"
            autocomplete="off"
            data-testid="professional-waitlist-honeypot-input"
          />

          <wil-cta-button
            [disabled]="!isFormValid"
            [loading]="isLoading()"
            ctaText="Yes, let me know"
            (ctaClick)="onSubmit()"
            [style]="'primary'"
            [size]="'large'"
            data-testid="professional-waitlist-submit-button"
          ></wil-cta-button>
        </form>

        <p class="professional-promotion__white-label">
          or Embed the Wheel directly into your programme -
          <a href="/for-coaches-and-programmes" target="_blank" rel="noopener noreferrer">learn how it works.</a>
        </p>
        } @if (isSubmitted() && !hasError()) {
        <div class="professional-promotion__message" data-testid="professional-waitlist-success">
          <h3 data-testid="professional-waitlist-success-title">Thanks for the interest!</h3>
          <p data-testid="professional-waitlist-success-message">We'll notify you when the professional plan becomes available.</p>
        </div>
        } @if (hasError()) {
        <p class="professional-promotion__message professional-promotion__message--error" data-testid="professional-waitlist-error">
          Something went wrong. Please try again.
        </p>
        }
      </article>
    </div>
  </section>
</div>
